export const SET_CLIENT_ITEMS = "SET_CLIENT_ITEMS";
export const SET_CUSTOM_ITEMS = "SET_CUSTOM_ITEMS";
export const SET_COMPANY_ITEMS = "SET_COMPANY_ITEMS";
export const SET_PRODUCT_ITEMS = "SET_PRODUCT_ITEMS";
export const SET_CONTRACT_ITEMS = "SET_CONTRACT_ITEMS";
export const SET_FILTERS = "SET_FILTERS";
